<template>
  <div class="flex items-stretch h-full">
    <div class="hidden md:flex w-2/4 bg-primary dark:bg-primary-900 text-xs relative">
      <img class="object-cover mix-blend-soft-light filter grayscale" src="@/assets/img/grupo-login.png" alt="RGCC. Imagen decorativa, tornos de entrada a las instalaciones" />
    </div>
    <div class="w-full flex flex-col min-h-full">
      <div class="main flex-grow">
        <div class="w-full flex flex-col min-h-full dark:bg-darkblue-900">
          <div class="flex flex-grow items-center justify-center">
            <div class="w-full max-w-sm relative">
              <img src="@/assets/img/logo-rgcc.svg" class="mx-auto mb-6 brand" alt="Real Grupo Cultural Covadonga - Control de Accesos" title="Real Grupo Cultural Covadonga - Control de Accesos" />
              <form class="px-4 sm:px-0">
                <div class="flex flex-col">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">Usuario</label>
                  <div>
                    <input type="text" value="" required class="peer rounded border-2 border-secondary-200 focus:outline-none focus:border-secondary hover:border-secondary-300 px-4 py-2 w-full" />
                    <p class="mt-1 text-sm invisible peer-invalid:visible text-gray-600">Introduzca su número de socio</p>
                  </div>
                </div>
                <div class="flex flex-col mt-2">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">Contraseña</label>
                  <div>
                    <input type="password" required value="" class="peer rounded border-2 border-secondary-200 focus:outline-none focus:border-secondary hover:border-secondary-300 px-4 py-2 w-full" />
                    <p class="mt-1 text-sm invisible peer-invalid:visible text-gray-600">Introduzca su contraseña</p>
                  </div>
                </div>

                <div class="mt-6">
                  <button class="px-6 py-3 bg-secondary text-white w-full rounded hover:bg-secondary-600 font-bold">Acceder</button>
                  <p class="mt-2 text-sm text-red-700 text-center">El usuario o contraseña introducidos no es válido</p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-shrink-0 h-10 flex items-center justify-center dark:bg-darkblue-900">
        <p class="text-sm text-center text-gray-500 dark:text-neutral-400">&copy; 2022 RGCC | Este site solo usa cookies funcionales. Ver <a href="https://www.rgcc.es/aviso-legal" class="text-secondary underline" target="_blank">Aviso Legal</a>, <a href="https://www.rgcc.es/cookies" class="text-secondary underline" target="_blank">Política de cookies</a> y <a href="https://www.rgcc.es/privacidad" target="_blank" class="text-secondary underline">Privacidad</a></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PublicLoginHtmlOnly'
}
</script>
